import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Trigger from '@cloud-sn/v-trigger';
import placements from './placements';
import MonthYearDecadeCalendar from '../monthYearDecadeCalendar';
export default {
  name: 'MonthYearDecadePicker',
  props: {
    prefixCls: {
      type: String,
      default: 'v-calendar'
    },
    pickerPrefixCls: {
      type: String,
      default: function _default() {
        return "".concat(this.prefixCls, "-picker");
      }
    },
    mode: {
      type: String,
      default: 'month',
      validator: function validator(v) {
        return ['month', 'year', 'decade'].indexOf(v) > -1;
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    locale: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Date,
      default: undefined
    },
    format: {
      type: String,
      default: undefined
    },
    disabledMonth: {
      type: Function,
      default: undefined
    },
    disabledYear: {
      type: Function,
      default: undefined
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    builtinPlacements: {
      type: Object,
      default: function _default() {
        return placements;
      }
    },
    align: {
      type: Object,
      default: function _default() {
        return {// points: ['tl', 'tl'],
        };
      }
    },
    placement: {
      type: String,
      default: 'bottomLeft'
    },
    transitionName: {
      type: String,
      default: 'slide-up'
    },
    animation: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      innerVisible: false
    };
  },
  watch: {
    visible: function visible(nVal) {
      this.setInnerVisible(nVal);
    }
  },
  created: function created() {
    this.setInnerVisible(this.visible);
  },
  methods: {
    setInnerVisible: function setInnerVisible(visible) {
      this.innerVisible = visible;
    },
    onPopupVisibleChange: function onPopupVisibleChange(visible) {
      this.setInnerVisible(visible);
      this.$emit('open-change', visible);
    },
    onChange: function onChange(val) {
      this.setInnerVisible(false);
      this.$emit('change', val);
    },
    onPanelChange: function onPanelChange() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['panel-change'].concat(args));
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        prefixCls = this.prefixCls,
        pickerPrefixCls = this.pickerPrefixCls,
        mode = this.mode,
        value = this.value,
        locale = this.locale,
        format = this.format,
        disabledMonth = this.disabledMonth,
        disabledYear = this.disabledYear,
        innerVisible = this.innerVisible,
        disabled = this.disabled,
        align = this.align,
        placement = this.placement,
        builtinPlacements = this.builtinPlacements,
        getPopupContainer = this.getPopupContainer,
        animation = this.animation,
        transitionName = this.transitionName,
        onPopupVisibleChange = this.onPopupVisibleChange,
        onChange = this.onChange,
        onPanelChange = this.onPanelChange;
    var triggerProps = {
      prefixCls: pickerPrefixCls,
      visible: innerVisible,
      actions: disabled ? [] : ['click'],
      popupAlign: align,
      popupPlacement: placement,
      builtinPlacements: builtinPlacements,
      getPopupContainer: getPopupContainer,
      destroyPopupOnHide: true,
      popupTransitionName: transitionName,
      poupAnimation: animation
    };
    return h(Trigger, {
      "props": _objectSpread({}, triggerProps),
      "on": _objectSpread({}, {
        'popup-visible-change': onPopupVisibleChange
      })
    }, [h("template", {
      "slot": "trigger"
    }, [$slots.trigger]), h(MonthYearDecadeCalendar, _mergeJSXProps([{}, {
      props: {
        prefixCls: prefixCls,
        mode: mode,
        value: value,
        locale: locale,
        format: format,
        disabledMonth: disabledMonth,
        disabledYear: disabledYear
      },
      on: {
        'panel-change': onPanelChange,
        change: onChange
      },
      slot: 'popup'
    }]))]);
  }
};